module.exports = __webpack_public_path__ + "media/images/athletes/2817-411adea53268c3572217fadf2c6fb84b.png";